export default {
  STOCK: '證券賬戶',
  FUTURES: '期貨賬戶',
  FOREX: '外匯賬戶',
  IB: 'EddidPro賬戶',
  PM: '現貨黃金賬戶',
  accountInfo: '賬戶信息',
  transId: '交易單號',
  search: '搜索',
  export: '導出',
  clientAccount: '客戶賬號',
  transDate: '交易日期',
  valueDate: '結算日期',
  productName: '產品名稱',
  number: '數量',
  tranAmount: '交易金額',
  commission: '佣金',
  market: '市場',
  orderType: '訂單類型',
  avgPrice: '買入／賣出價',
  selectStartTime: '請選擇開始日期',
  selectEndTime: '請選擇結束日期',
  selectTimeError: '結束時間不能小於開始時間',
  B: '買入',
  S: '賣出',
  noData: '無交易記錄'
}
